import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, TextField, Autocomplete, Box } from "@mui/material";
import { useHistory } from "react-router";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "../../components/Dialog";
import Autocomplete2 from "../../components/Autocomplete2";
import { gridStyle } from "../../utils/formStyles";
import { notify } from "../../reducers/NotifierReducer";
import { handleError } from "../../reducers/ErrorReducer";
import { createSecGroup, findSecCode } from "../../pages/Security/SecFunction";
import { closeAddSecRole } from "../../reducers/DialogsReducer";
import { notifyDataUpdate } from "../../reducers/DataUpdateReducer";
import { PATH_SECURITY } from "../../utils/routeConstants";
import { securityPaths } from "../../utils/enums";

const AddSecRoleDialog = (props) => {
  const { type, ptsGroupID } = props.data || {};
  const { ptsAgencies } = props.dictionary.dictionary;
  const [name, setName] = useState("");
  const [currentType, setCurrentType] = useState(null);
  const [currentAgency, setCurrentAgency] = useState(null);
  const [allTypes, setAllTypes] = useState([]);
  const history = useHistory();

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    const types = await findSecCode("grouptype");
    setAllTypes(types);
  };

  const close = () => {
    props.closeAddSecRole();
  };

  const save = async () => {
    const data = {
      Label: name,
      Type: currentType?.Code || null,
      AgencyID: currentAgency?.AgencyID || null,
    };
    try {
      const result = await createSecGroup(data, ptsGroupID);
      if (type === "copy-role") {
        history.push({
          pathname: `${PATH_SECURITY}/${securityPaths.ROLEANDPERMISSION}`,
          search: `?roleId=${result.ptsGroupID}`,
        });
      }
      props.notifyDataUpdate({ type: "add-role", data: result.ptsGroupID });
      props.notify("New Role Created", "success");

      props.closeAddSecRole();
    } catch (err) {
      props.handleError(err, "Error Creating New Role");
    }
  };

  const renderActions = () => (
    <>
      <Button
        color="primary"
        variant="contained"
        autoFocus
        onClick={save}
        disabled={!name}
        startIcon={<SaveIcon />}
      >
        Save
      </Button>
      <Button color="primary" onClick={close} startIcon={<CloseIcon />}>
        Close
      </Button>
    </>
  );

  const renderName = () => (
    <TextField
      label="Role Name"
      variant="outlined"
      value={name}
      size="small"
      onChange={(e) => setName(e.target.value)}
      fullWidth
    />
  );

  const renderType = () => (
    <Autocomplete
      className="mt-3"
      disablePortal
      options={allTypes}
      value={currentType}
      onChange={(e, newValue) => setCurrentType(newValue)}
      getOptionLabel={(option) => option.Code || ""}
      renderOption={(props, option) => (
        <li {...props}>
          {option.Code} {option.Description ? `- ${option.Description}` : ""}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label="Role Type" variant="outlined" />
      )}
      size="small"
    />
  );

  const renderAgency = () => (
    <Box sx={{ mt: 3 }}>
      <Autocomplete2
        options={ptsAgencies}
        sx={{ ...gridStyle(200, 800), m: 0 }}
        onChange={(e, newValue) => setCurrentAgency(newValue)}
        value={currentAgency}
        label="Agency"
        getOptionLabel={(option) => option.AgencyID}
        isOptionEqualToValue={(option, value) =>
          option.AgencyID === value?.AgencyID
        }
        renderOption={(props, option) => <li {...props}>{option.AgencyID}</li>}
      />
    </Box>
  );

  return (
    <Dialog onClose={close} title="Add New Role" actions={renderActions()}>
      <Box>
        {renderName()}
        {renderType()}
        {renderAgency()}
      </Box>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  dictionary: state.dictionary,
});

export default connect(mapStateToProps, {
  closeAddSecRole,
  handleError,
  notify,
  notifyDataUpdate,
})(AddSecRoleDialog);
